import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { COLORS } from '../commonComponents/COLORS';

export const WhiteAppBar = styled(AppBar)({
    backgroundColor: '#fff',
    boxShadow: 'none',
});

export const DrawerContent = styled(Box)({
    width: '40vh',
    height: '100vh',
    backgroundColor:COLORS.purpleColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px',
    color: '#fff',
});
